import React, { useEffect, useState, useContext } from 'react';
import Cookies from 'js-cookie';
import classes from './AccountPage.module.css';
import { userprofileSave, updateUserNameApi } from '../http/http';
import UnsubModal from '../components/UnsubModal';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSpinStatus,
  fetchUserDetails,
  fetchUserTotalPoints,
} from '../store/slices/userSlice';

import { useNavigate } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import { LanguageContext } from './LanguageContext';
import { baseImageUrl } from '../utils/constants';
import { ACCOUNT, pageT } from '../utils/i18n';

const AccountPage = () => {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, ACCOUNT);

  const dispatch = useDispatch();

  const [userName, setUserName] = useState('Player');
  const [profileImg, setProfileImg] = useState(
    'https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_wordcount_boost&w=740&q=80'
  );

  const [editMode, setEditMode] = useState(false);
  const [newName, setNewName] = useState('');
  const [usertitle, setUsertitle] = useState('good player');
  const [showUnsubModal, setShowUnsubModal] = useState(false);

  const userDetails = useSelector((state) => state.user.details);
  const points = useSelector((state) => state.user.totalPoints);
  const spinStatus = useSelector((state) => state.user.spinStatus);
  const currentLevel = userDetails?.game_level ?? 0;

  const isWheelUnlocked = currentLevel >= 10 && spinStatus === 'enable';

  const saveUserName = async () => {
    const token = Cookies.get('token');
    if (!token) return;

    try {
      const res = await updateUserNameApi({ token, name: newName });
      dispatch(fetchUserDetails(token));
      dispatch(fetchUserTotalPoints(token));
      if (res?.data?.success) {
        setEditMode(false);
        alert(t.nameUpdated);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // const fetchUserLevels = async () => {
  //   const user_id = Cookies.get("user_id");
  //   if (!user_id) return;

  //   try {
  //     const res = await userlevelsApi(user_id);
  //     const data = res?.data?.result?.[0];
  //     setCurrentLevel(data?.level_no || 0);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  useEffect(() => {
    const token = Cookies.get('token');
    if (!token) {
      navigate('/');
      return;
    }

    dispatch(fetchUserDetails(token));
    dispatch(fetchUserTotalPoints(token));
  }, [dispatch, navigate]);

  useEffect(() => {
    if (!userDetails) return;
    setUserName(userDetails?.name || 'Player');
    setNewName(userDetails?.name || '');
    setUsertitle(userDetails?.user_title || 'good player');

    if (userDetails?.profile_url) {
      setProfileImg(`${baseImageUrl}${userDetails.profile_url}`);
    }
  }, [userDetails]);

  useEffect(() => {
    const token = Cookies.get('token');
    if (!token) return;
    if ((userDetails?.game_level ?? 0) >= 10) {
      dispatch(fetchSpinStatus(token));
    }
  }, [dispatch, userDetails?.game_level]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewURL = URL.createObjectURL(file);
    setProfileImg(previewURL);
    uploadProfileImage(file);
  };

  const uploadProfileImage = async (file) => {
    const token = Cookies.get('token');
    if (!token) return;

    const formData = new FormData();
    formData.append('profile', file);

    try {
      const res = await userprofileSave({ token, formData });
      dispatch(fetchUserDetails(token));
      // if (res?.data?.profile_url) {
      // setProfileImg(`${baseImageUrl}${res.data.profile_url}`);
      // }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className={classes.accountPage}>
      <div className={classes.languageBox}>
        <LanguageSelector />
      </div>

      <div className={classes.profileCard}>
        <div className={classes.header}>
          <div className={classes.avatarWrapper}>
            <div className={classes.avatar}>
              <img
                src={profileImg}
                alt={userName}
                className={classes.avatarImg}
              />
            </div>

            <div
              className={classes.editIcon}
              onClick={() =>
                document.getElementById('profileImageInput').click()
              }
              title={t.editProfile}
            >
              ✏️
            </div>

            <input
              type="file"
              accept="image/*"
              id="profileImageInput"
              style={{ display: 'none' }}
              onChange={handleImageChange}
            />
          </div>

          <div className={classes.userInfo}>
            {editMode ? (
              <div>
                <input
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  className={classes.nameInput}
                />
                <button onClick={saveUserName} className={classes.saveBtn}>
                  {t.save}
                </button>
                <button
                  onClick={() => setEditMode(false)}
                  className={classes.cancelBtn}
                >
                  {t.cancel}
                </button>
              </div>
            ) : (
              <div>
                <h2>{userName}</h2>
                <span
                  className={classes.editNameIcon}
                  onClick={() => setEditMode(true)}
                >
                  ✏️
                </span>
              </div>
            )}

            <p>{t.account_subtitle}</p>
          </div>
        </div>
        <div>
          <h1 className={classes.usertitle}>{usertitle}</h1>
        </div>

        <div className={classes.statsGrid}>
          <div className={classes.statCard}>
            <div className={classes.statIcon}>🏆</div>
            <div className={classes.statValue}>{points}</div>
            <div className={classes.statLabel}>{t.pointText}</div>
          </div>

          <div className={classes.statCard}>
            <div className={classes.statIcon}>📦</div>
            <div className={classes.statValue}>{currentLevel + 1}</div>
            <div className={classes.statLabel}>{t.currentlevel}</div>
          </div>

          <div className={classes.statCard}>
            <div className={classes.statIcon}>🔥</div>
            <div className={classes.statValue}>{currentLevel * 2}%</div>
            <div className={classes.statLabel}>{t.gameprogress}</div>
          </div>

          <div className={classes.statCard}>
            <h4>{t.wheelSpin}</h4>

            <div
              className={`${classes.spin} ${
                !isWheelUnlocked ? classes.locked : ''
              }`}
              onClick={() => {
                if (!isWheelUnlocked) return;
                navigate('/silverchit');
              }}
            >
              <img
                src="https://cdn.pixabay.com/photo/2021/12/16/03/04/spin-the-wheel-6873663_960_720.png"
                alt="Wheel"
                className={classes.wheelImage}
              />

              {!isWheelUnlocked && (
                <div className={classes.lockOverlay}>
                  🔒 {t.locked} <br />
                  <small>
                    {currentLevel < 10 ? t.completeLevel10 : t.alreadySpin}
                  </small>
                </div>
              )}
            </div>
          </div>

          <div className={classes.statCard}>
            <h4>{t.goHome}</h4>
            <div
              onClick={() => {
                navigate('/home');
              }}
            >
              <img
                src="https://static.vecteezy.com/system/resources/previews/018/842/704/original/cute-3d-home-button-real-estate-mortgage-loan-concept-icon-3d-render-free-png.png"
                alt="Wheel"
                className={classes.homeImage}
              />
            </div>
          </div>

          <div className={classes.statCard}>
            <h4>{t.userHistory}</h4>

            <div
              className={classes}
              onClick={() => {
                navigate('/user-history');
              }}
            >
              <img
                src="https://static.vecteezy.com/system/resources/previews/016/774/583/original/3d-user-icon-on-transparent-background-free-png.png"
                alt="History"
                className={classes.homeImage}
              />
            </div>
          </div>
        </div>
        <div className={classes.progressBox}>
          <div className={classes.progressTitle}>{t.levelprogress}</div>
          <div className={classes.progressBar}>
            <div
              className={classes.progressFill}
              style={{ width: `${currentLevel * 2}%` }}
            ></div>
          </div>
        </div>

        <div className={classes.actionButtons}>
          <button
            className={classes.unsubscribeBtn}
            onClick={() => setShowUnsubModal(true)}
          >
            {t.btn}
          </button>
        </div>
      </div>

      {showUnsubModal ? (
        <UnsubModal t={t} onClose={() => setShowUnsubModal(false)} />
      ) : null}
    </div>
  );
};

export default AccountPage;
